import { PropsWithChildren } from 'react';

export const MsgWrap = ({ children, className }: PropsWithChildren<{ className?: string }>) => {
  return (
    <div
      className={`rounded-xl p-2 text-white inline-block ${className}`}
      style={{
        background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.2) 100%)',
        backdropFilter: 'blur(6px)',
      }}
    >
      {children}
    </div>
  );
};
